import React, { useContext, useEffect } from "react";
import HeaderInner from "../../Components/HeaderInner";
import Textheader from "../../Components/Textheader";
import Clientinfo from "../../Components/Clientinfo";
import Post1 from "../../assets/images/Entertainment/Entertainment-1.png";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import { trackOrderPaymentSucceeded } from "../../utils/mixpanel";
function MaintenanceOrderPlaced() {
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  // TODO: remove — local mock so the post-payment screen can be previewed
  const MOCK_DATA = {
    title: "Maintenance",
    orderedAt: "Aug 14, 2026 10:23",
    roomNumber: "102",
    order_id: 20512,
    orderNumber: "#16535071",
    category: {
      id: "2",
      image:
        "https://d3l5wxnahfuscp.cloudfront.net/uploaded_files/images/maintenance_images/OdBhP7IK51rx4wCbEnDnFQ5lXrIMJe7KMCw2jhe8.png",
      name: "AC",
    },
    images: [],
    note: "Note 100",
    price: 155,
    headerColor: "#000000",
    tax_inclusive: 0,
    color: "#000000",
  };
  const data = location.state?.metadata;
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  const { t, i18n } = useTranslation();
  // console.log("location.state?.metadata", location.state?.metadata);
  const currency = localStorage.getItem("currency");

  const price =
    data?.res?.category?.price ||
    data?.category?.price ||
    data?.res?.price ||
    data?.price;
  const hasPrice = price && price !== "0.00" && Number(price) !== 0;
  const note = data?.res?.note || data?.note;

  // useEffect(() => {
  //   trackOrderPaymentSucceeded({
  //     order_number: data?.res?.orderNumber || data?.orderNumber || "",
  //     payment_method: "",
  //     gateway_transaction_id: "",
  //     amount: 0,
  //     currency: localStorage.getItem("currency") || "AED",
  //   });
  // }, []);

  return (
    <div className={theme ? "food" : ""}>
      {theme ? <Title title={"Order Details"} /> : <HeaderInner />}
      <main className="bg-white pad-top-0 back-white">
        <Textheader />
        <Clientinfo
          roomNumber={data?.res?.roomNumber || data?.roomNumber}
          orderNumber={data?.res?.orderNumber || data?.orderNumber}
          orderedAt={data?.res?.orderedAt || data?.orderedAt}
        />

        <div className="full-heading grey-bg  flex">
          <h2 className="blck co-header">{t("Order Details")}</h2>
        </div>
        <div className="full-div padd-div">
          <div className="booking-order-detail">
            {(data?.res?.category || data?.category) && (
              <div
                className="ma_category flex"
                style={{
                  display: "flex",
                  justifyContent: "space-between",

                  width: "100%",
                }}
              >
                <div style={{ display: "flex", gap: "4px" }}>
                  {(data?.res?.category?.image || data?.category?.image) && (
                    <img
                      className="ma_category_img"
                      src={data?.res?.category?.image || data?.category?.image}
                      alt={data?.res?.category?.name || data?.category?.name}
                      style={{ width: "50px", height: "50px" }}
                    />
                  )}
                  <p className="ma_category_name">
                    {data?.res?.category?.name || data?.category?.name}
                  </p>
                </div>
                {data?.res?.category?.price &&
                  data?.res?.category?.price !== "0.00" && (
                    <div
                      className="ma_category_info"
                      style={{ display: "flex" }}
                    >
                      <p className="ma_category_price">
                        {data?.res?.category?.price || data?.category?.price}{" "}
                        {currency}
                      </p>
                    </div>
                  )}
              </div>
            )}
            <div className="ma_images">
              {(data?.res?.images || data?.images || []).map((image, idx) => {
                return <img key={idx} src={image} alt="" />;
              })}
            </div>
            <div className="txt-pnl">
              <p>{data?.res?.note || data?.note}</p>
            </div>
          </div>
        </div>
        <div className="spacer-20"></div>
        <div className="full-div padd-div text-center">
          <Link className="reg-btn big" to={`/${room_uuid}/qr-code`}>
            {t("Back to Home")}
          </Link>
        </div>
      </main>
      {theme && <NewFooter />}
    </div>
  );
}
export default MaintenanceOrderPlaced;
